import React, { useState } from 'react';
import './CategoryTabs.css';
import { Icon } from './Icon.js';

const CategoryTabs = ({ categories, activeCategory, onCategoryChange }) => {
  const allCategories = ['all', 'favourites', ...categories];
  const [isExpanded, setIsExpanded] = useState(false);

  const getDisplayName = (category) => {
    if (category === 'all') return 'All';
    if (category === 'favourites') return 'Favourites';
    return category.charAt(0).toUpperCase() + category.slice(1);
  };

  const activeDisplayName = getDisplayName(activeCategory);

  return (
    <div 
      className={`category-tabs-horizontal ${isExpanded ? 'expanded' : ''}`}
      onMouseEnter={() => setIsExpanded(true)}
      onMouseLeave={() => setIsExpanded(false)}
    >
      <div className="category-trigger-label">
        <span className="categories-text">Categories</span>
        <span className="active-badge">{activeDisplayName}</span>
        <Icon name="ChevronRight" className="expand-icon" />
      </div>
      
      <div className="category-tabs-expandable">
        {allCategories.map((category) => (
          <button
            key={category}
            className={`category-tab-item ${activeCategory === category ? 'active' : ''}`}
            onClick={() => onCategoryChange(category)}
          >
            {getDisplayName(category)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryTabs; 